<template>
  <div
    class="min-h-screen flex items-center justify-center
      bg-gradient-to-br from-diligint-light via-white to-diligint-dark
      dark:bg-gradient-to-br dark:from-gray-900 dark:via-gray-800 dark:to-blue-900"
  >  <div class="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl shadow-lg p-8">
      <div class="flex flex-col items-center mb-6">
        <DiligintLogo class="h-10 w-auto text-diligint dark:text-white" />
        <h2 class="text-2xl font-bold text-diligint-dark dark:text-diligint-light">Sign in to your account</h2>
        <p class="text-diligint-light text-sm mt-1 dark:text-gray-400">Welcome back! Please enter your details.</p>
      </div>
      <form @submit.prevent="login">
        <div class="mb-4">
          <label class="block text-diligint-dark dark:text-diligint-light mb-1" for="identifier">Email or Username</label>
          <input
            id="identifier"
            v-model="identifier"
            type="text"
            required
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-diligint-dark dark:focus:ring-white bg-white dark:bg-gray-800 text-diligint-dark dark:text-white"
            placeholder="you@email.com or username"
            autocomplete="username"
          />
        </div>
        <div class="mb-6">
          <label class="block text-diligint-dark dark:text-diligint-light mb-1" for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            required
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-diligint-dark dark:focus:ring-white bg-white dark:bg-gray-800 text-diligint-dark dark:text-white"
            placeholder="••••••••"
            autocomplete="current-password"
          />
        </div>
        <button
          type="submit"
          class="w-full bg-diligint-dark hover:bg-diligint-hover text-white font-semibold py-2 rounded-lg transition"
          :disabled="auth.loading"
        >
          <span v-if="auth.loading">Signing in...</span>
          <span v-else>Sign In</span>
        </button>
        <div v-if="error" class="mt-4 text-red-600 text-center text-sm">
          {{ error }}
        </div>
      </form>
      <div class="mt-6 text-center text-sm text-diligint-light dark:text-gray-400">
        <RouterLink to="/reset-password" class="text-diligint-dark hover:underline dark:text-diligint-light">Forgot password?</RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import DiligintLogo from '@/assets/DiligintLogo.vue'

const identifier = ref('')
const password = ref('')
const auth = useAuthStore()
const router = useRouter()

const error = ref(null)
const loading = ref(false)

async function login() {
  loading.value = true
  error.value = null
  const payload = identifier.value.includes('@')
    ? { email: identifier.value, password: password.value }
    : { username: identifier.value, password: password.value }
  const success = await auth.login(payload)
  loading.value = false
  if (success) {
    router.push('/')
  } else {
    error.value = auth.error
  }
}
</script>